import React, {Component} from 'react';
import AdminSession from './Session';
import * as firebase from 'firebase';

/**
 * this component is the simulationContainer for admins
 * which holds all sessions
 * reads from playable sessions
 */
class AdminSessionContainer extends Component {
    constructor(props) {
        console.log("AdminSessionContainer constructor ", props);
        super(props);
        this.state = {
            sessions: []
        };
    }

    /**
     * on mount, go to Playable Sessions, loop
     * through and grab sessionid and title.
     * then set that data to sessions state
     */
    componentDidMount() {
        console.log("AdminSessionContainer componentDidMount", this.props);

        let sessionid, title, creator, solo;
        let self = this;
        this.playableRef = firebase.database().ref().child(this.props.institution).child("PlayableSessions");
        this.playableRef.on('value', snap => {
            let rawData = snap.val();
            let sesses = [];
            for (var key in rawData) {
                sessionid = key;
                if (rawData[key]) {
                    title = rawData[key].Title;
                    creator = rawData[key].Creator;
                    solo = rawData[key].Solo;
                    sesses.push({
                        "SessionId": sessionid,
                        "Title": title,
                        "Creator": creator,
                        "Solo": solo
                    });
                }
                self.setState({
                    sessions: sesses.reverse()
                });
            }
        })
    }

    /**
     *
     */
    componentWillUnmount() {
        console.log("AdminSessionContainer componentWillUnmount");
        this.playableRef.off();
    }

    /**
     *
     * @returns {*}
     */
    render() {
        console.log("AdminSessionContainer render");
        return (
            <div className='session-list'>
                <table>
                    <tbody>
                    {this.state.sessions.map(function (sess, index) {
                        return (
                            <AdminSession key={index} user={this.props.user}
                                          sessionid={sess.SessionId}
                                          institution={this.props.institution} title={sess.Title}
                                          creator={sess.Creator} solo={sess.Solo}/>
                        );
                    }.bind(this))}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default AdminSessionContainer;



// WEBPACK FOOTER //
// ./src/components/Dashboard/SessionList.js